/* Capelli — strip "Paga de forma segura con" bajo el botón de compra (réplica de summerkids.cl / .sk-pay).
   Se inyecta por JS para NO editar la sección de producto (grande, riesgo de corrupción en upload).
   Apple/Google Pay = SVG inline; Venti y Mercado Pago = <img> (CDN Shopify). Estilos en capelli-badges.css (.cap-pay). */
(function () {
  'use strict';
  var BUILT = 'cap-pay';

  var VENTI = 'https://cdn.shopify.com/s/files/1/0611/9378/1448/files/48cda8ae58599e9dea2be9d308c648198a18870cedabc07413225fb927aa4ddd-small-logo_green-h400.png?v=1781611584';
  var MP = 'https://cdn.shopify.com/s/files/1/0611/9378/1448/files/Mercado_Pago_svg.webp?v=1781611583';

  function html() {
    return '' +
      '<p class="cap-pay__label">Paga de forma segura con</p>' +
      '<div class="cap-pay__row">' +
        '<span class="cap-pay__chip" aria-label="Apple Pay">' +
          '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><path fill="#000" d="M17.05 12.04c-.03-2.6 2.13-3.85 2.22-3.91-1.21-1.78-3.1-2.02-3.77-2.05-1.61-.16-3.14.95-3.95.95-.81 0-2.07-.93-3.4-.9-1.75.03-3.36 1.02-4.26 2.58-1.82 3.16-.47 7.83 1.31 10.39.86 1.25 1.89 2.66 3.24 2.61 1.3-.05 1.79-.84 3.36-.84 1.57 0 2.01.84 3.39.81 1.4-.03 2.28-1.28 3.14-2.54.98-1.46 1.39-2.87 1.41-2.94-.03-.01-2.72-1.04-2.74-4.13zM14.6 4.45c.72-.87 1.2-2.08 1.07-3.28-1.03.04-2.28.69-3.02 1.56-.66.77-1.24 2-1.08 3.17 1.15.09 2.32-.58 3.03-1.45z"></path></svg>' +
          '<span class="cap-pay__txt">Pay</span>' +
        '</span>' +
        '<span class="cap-pay__chip" aria-label="Google Pay">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">' +
            '<path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47a5.4 5.4 0 0 1-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z"></path>' +
            '<path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A11.99 11.99 0 0 0 12 24z"></path>' +
            '<path fill="#FBBC05" d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29A11.86 11.86 0 0 0 0 12c0 1.94.46 3.77 1.29 5.38l3.98-3.09z"></path>' +
            '<path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.69 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"></path>' +
          '</svg>' +
          '<span class="cap-pay__txt">Pay</span>' +
        '</span>' +
        '<span class="cap-pay__chip" aria-label="Venti">' +
          '<img class="cap-pay__img" src="' + VENTI + '" alt="Venti" height="15">' +
        '</span>' +
        '<span class="cap-pay__chip" aria-label="Mercado Pago">' +
          '<img class="cap-pay__img" style="height:34px" src="' + MP + '" alt="Mercado Pago">' +
        '</span>' +
      '</div>';
  }

  function build() {
    // solo en la ficha de producto: ancla = contenedor de botones de compra
    var anchor = document.querySelector('.product-form-buttons') ||
                 document.querySelector('form.shopify-product-form');
    if (!anchor) return;
    if (document.querySelector('.' + BUILT)) return; // evita duplicado
    var box = document.createElement('div');
    box.className = BUILT;
    box.innerHTML = html();
    anchor.insertAdjacentElement('afterend', box);
  }

  function scanSoon() { build(); setTimeout(build, 300); setTimeout(build, 1200); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanSoon);
  else scanSoon();
  window.addEventListener('load', build);

  // el form puede re-renderizarse (Section Rendering API al cambiar variante) y quitar el strip → re-inyectar
  try {
    var mo = new MutationObserver(function () { if (!document.querySelector('.' + BUILT)) build(); });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
